import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=b3470802"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports